const ROOT = (process.env.REACT_APP_BACKEND_URL ?? '') + '/api/reporting-finance';
export async function reporting(path, { method = 'GET', body, signal } = {}) {
  // Le transport global de lib/http ajoute session et CSRF.
  const r = await fetch(ROOT + path, {
    method, signal, headers: { 'Content-Type': 'application/json' },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data = await r.json();
  if (!r.ok) {
    const detail = data.detail;
    throw new Error(typeof detail === 'string' ? detail : JSON.stringify(detail ?? 'Erreur serveur'));
  }
  return data;
}
export const montantReporting = (value) => value == null ? 'Indisponible'
  : (value / 1000).toLocaleString('fr-TN', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + ' TND';
export function telechargerContexte(data) {
  const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'contexte-financier-' + data.exercice + '.json';
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
